"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG = exports.CameraSourceSettings = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Join = require("../../Join");
var _utils = require("../../Join/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _logger = require("@studio/logger");
var _chime = require("@studio/chime");
var _constants = require("@studio/constants");
var _Notification = require("../../Notification");
var _CameraSourceSettings = require("./CameraSourceSettings.styled");
var _useNotification3 = require("../../../hooks/useNotification");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LOG = exports.LOG = new _logger.StudioLogger('source-settings');
var CameraSourceSettings = exports.CameraSourceSettings = function CameraSourceSettings(_ref) {
  var _transformedVideoInpu;
  var meetingSession = _ref.meetingSession,
    _title = _ref.title,
    _description = _ref.description,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    audioInputDeviceId = _ref.audioInputDeviceId,
    audioOutputDeviceId = _ref.audioOutputDeviceId,
    videoInputDeviceId = _ref.videoInputDeviceId,
    isCameraAvailable = _ref.isCameraAvailable,
    _userBackground = _ref.userBackground,
    _ref$transformedVideo = _ref.transformedVideoInputs,
    _transformedVideoInputs = _ref$transformedVideo === void 0 ? [] : _ref$transformedVideo,
    uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    deleteUserVirtualBackground = _ref.deleteUserVirtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    user = _ref.user;
  var _useState = (0, _react.useState)(videoInputDeviceId),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedVideoInputId = _useState2[0],
    setSelectedVideoInputId = _useState2[1];
  var _useState3 = (0, _react.useState)(audioInputDeviceId),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedAudioInputId = _useState4[0],
    setSelectedAudioInputId = _useState4[1];
  var _useState5 = (0, _react.useState)(audioOutputDeviceId),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedAudioOutputId = _useState6[0],
    setSelectedAudioOutputId = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isCancelInProgress = _useState8[0],
    setIsCancelInProgress = _useState8[1];
  var _useState9 = (0, _react.useState)(_description),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    description = _useState10[0],
    setDescription = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    videoInput = _useState12[0],
    setVideoInput = _useState12[1];
  var _useState13 = (0, _react.useState)((_transformedVideoInpu = _transformedVideoInputs[0]) !== null && _transformedVideoInpu !== void 0 ? _transformedVideoInpu : null),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    transformedVideoInput = _useState14[0],
    setTransformedVideoInput = _useState14[1];
  var _useState15 = (0, _react.useState)(_userBackground),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    userBackground = _useState16[0],
    setUserBackground = _useState16[1];
  var virtualBackground = user === null || user === void 0 ? void 0 : user.virtualBackground;
  var _useNotification = (0, _useNotification3.useNotification)(),
    _useNotification2 = (0, _slicedToArray2["default"])(_useNotification, 2),
    notification = _useNotification2[0],
    showNotification = _useNotification2[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    isVideoChanging = _useState18[0],
    setIsVideoChanging = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    isVideoDisconnected = _useState20[0],
    setIsVideoDisconnected = _useState20[1];
  var initialFirstName = _title.split(' ')[0];
  var initialLastName = _title.split(' ').slice(1).join(' ');
  var _useState21 = (0, _react.useState)(initialFirstName),
    _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
    firstName = _useState22[0],
    setFirstName = _useState22[1];
  var _useState23 = (0, _react.useState)(initialLastName),
    _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
    lastName = _useState24[0],
    setLastName = _useState24[1];
  var title = "".concat(firstName, " ").concat(lastName);
  var _useState25 = (0, _react.useState)([]),
    _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
    videoDevices = _useState26[0],
    setVideoDevices = _useState26[1];
  (0, _chime.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setVideoDevices,
    onDeviceChanged: setSelectedVideoInputId,
    selectedDeviceId: selectedVideoInputId,
    deviceType: _constants.VIDEO_INPUT
  });
  var _useState27 = (0, _react.useState)([]),
    _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
    audioInputDevices = _useState28[0],
    setAudioInputDevices = _useState28[1];
  (0, _chime.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setAudioInputDevices,
    onDeviceChanged: setSelectedAudioInputId,
    selectedDeviceId: selectedAudioInputId,
    deviceType: _constants.AUDIO_INPUT
  });
  var _useState29 = (0, _react.useState)([]),
    _useState30 = (0, _slicedToArray2["default"])(_useState29, 2),
    audioOutputDevices = _useState30[0],
    setAudioOutputDevices = _useState30[1];
  (0, _chime.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setAudioOutputDevices,
    onDeviceChanged: setSelectedAudioOutputId,
    selectedDeviceId: selectedAudioOutputId,
    deviceType: _constants.AUDIO_OUTPUT
  });
  var handleVideoInputChange = function handleVideoInputChange(videoInput) {
    var _videoInput$device;
    setSelectedVideoInputId((_videoInput$device = videoInput === null || videoInput === void 0 ? void 0 : videoInput.device) !== null && _videoInput$device !== void 0 ? _videoInput$device : videoInput);
    setVideoInput(videoInput);
  };
  var onTransformedVideoInputChange = function onTransformedVideoInputChange(transformedVideoInput) {
    setTransformedVideoInput(transformedVideoInput);
  };
  var hasTitle = title.trim().length > 0;
  var hasFirstNameExceededLimit = firstName.trim().length > 30;
  var hasLastNameExceededLimit = lastName.trim().length > 50;
  var hasDescriptionExceededLimit = description.trim().length > 80;
  var hasValidationError = !hasTitle || hasFirstNameExceededLimit || hasLastNameExceededLimit || hasDescriptionExceededLimit;
  (0, _react.useEffect)(function () {
    if (virtualBackground !== null && virtualBackground !== void 0 && virtualBackground.isDeleteFailed) {
      showNotification({
        message: _constants.DELETE_VIRTUAL_BACKGROUND_FAILURE_MSG,
        type: 'warning',
        linkMessage: '',
        delay: 3000,
        onClick: function onClick() {}
      });
      resetUserVirtualBackground();
    }
  }, [virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.isDeleteFailed]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
      var transformedVideoInputs, payload, sourceSettings;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            LOG.info("Attendee ".concat(title, " settings saved"));
            _context.next = 4;
            return (0, _utils.handleTransformedVideoInput)(userBackground, transformedVideoInput, setTransformedVideoInput);
          case 4:
            transformedVideoInputs = _context.sent;
            payload = {
              audioInputDeviceId: selectedAudioInputId,
              audioOutputDeviceId: selectedAudioOutputId,
              videoInputDeviceId: selectedVideoInputId,
              title: title,
              description: description,
              userBackground: userBackground,
              transformedVideoInputs: transformedVideoInputs,
              videoInput: videoInput
            };
            onSubmit(payload);
            sourceSettings = {
              audioInputDeviceId: selectedAudioInputId,
              audioOutputDeviceId: selectedAudioOutputId,
              videoInputDeviceId: selectedVideoInputId,
              title: title,
              description: description,
              userBackground: userBackground
            };
            LOG.info("CameraSourceSettings - ".concat(title, " updated settings"));
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCancel = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var transformedVideoInputs, videoFxConfig, input, videoInput, initialDataPayload;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsCancelInProgress(true);
            transformedVideoInputs = [];
            videoFxConfig = (0, _chime.getVideoFxConfig)(_userBackground, virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.imageURL);
            if (!(_userBackground !== _constants.BACKGROUND_OPTIONS.NONE && (_userBackground !== userBackground || selectedVideoInputId !== videoInputDeviceId))) {
              _context2.next = 12;
              break;
            }
            _context2.next = 6;
            return (0, _chime.clearBackgroundFilter)(transformedVideoInput);
          case 6:
            _context2.next = 8;
            return (0, _chime.transformVideo)(videoInputDeviceId, videoFxConfig);
          case 8:
            input = _context2.sent;
            transformedVideoInputs.push(input);
            _context2.next = 15;
            break;
          case 12:
            _context2.next = 14;
            return (0, _utils.handleTransformedVideoInput)(_userBackground, transformedVideoInput, setTransformedVideoInput);
          case 14:
            transformedVideoInputs = _context2.sent;
          case 15:
            videoInput = _userBackground !== _constants.BACKGROUND_OPTIONS.NONE ? transformedVideoInputs[0] : videoInputDeviceId; // When the camera is in use by another application, videoInput will be defined but startVideoInput will throw an error.
            // We need to ensure the camera is available before resetting video feed.
            // https://jira.cvent.com/browse/PROD-221807
            if (!(videoInput && isCameraAvailable)) {
              _context2.next = 19;
              break;
            }
            _context2.next = 19;
            return (0, _chime.startVideoInput)(meetingSession, videoInput);
          case 19:
            initialDataPayload = {
              audioInputDeviceId: audioInputDeviceId,
              audioOutputDeviceId: audioOutputDeviceId,
              videoInputDeviceId: videoInputDeviceId,
              userBackground: _userBackground,
              transformedVideoInputs: transformedVideoInputs,
              videoInput: videoInput
            };
            onCancel(initialDataPayload);
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleCancel() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleVideoReady = function handleVideoReady() {
    return setIsVideoChanging(false);
  };
  var isCancelDisabled = isCancelInProgress || isVideoChanging || isVideoDisconnected;
  var isSubmitDisabled = hasValidationError || isCancelInProgress || isVideoChanging;
  var footer = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
    onClick: handleCancel,
    color: "outline",
    className: "me-2",
    "data-testid": "cancel",
    disabled: isCancelDisabled
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    disabled: isSubmitDisabled,
    onClick: handleSubmit,
    color: "primary",
    "data-testid": "submit"
  }, "Done"));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CameraSourceSettings.NotificationComponentWrapper, null, notification.message !== '' && /*#__PURE__*/_react["default"].createElement(_Notification.Notification, (0, _extends2["default"])({
    key: notification.id
  }, notification))), /*#__PURE__*/_react["default"].createElement(_Join.Settings, {
    user: {
      _id: user === null || user === void 0 ? void 0 : user._id,
      firstName: firstName,
      lastName: lastName
    },
    selectedVideoInputId: selectedVideoInputId,
    selectedAudioInputId: selectedAudioInputId,
    selectedAudioOutputId: selectedAudioOutputId,
    meetingSession: meetingSession,
    videoDevices: (0, _utils.formatDevicesArrayForDropdown)(videoDevices),
    audioOutputDevices: (0, _utils.formatDevicesArrayForDropdown)(audioOutputDevices),
    audioInputDevices: (0, _utils.formatDevicesArrayForDropdown)(audioInputDevices),
    onVideoInputChange: handleVideoInputChange,
    onAudioInputChange: setSelectedAudioInputId,
    onAudioOutputChange: setSelectedAudioOutputId,
    onPresenterDescriptionChange: setDescription,
    isVideoPermissionDenied: audioInputDeviceId === '',
    isAudioPermissionDenied: false,
    footer: footer,
    presenterDescription: description,
    transformedVideoInput: transformedVideoInput,
    onTransformedVideoInputChange: onTransformedVideoInputChange,
    virtualBackground: virtualBackground,
    userBackground: userBackground,
    setUserBackground: setUserBackground,
    uploadUserVirtualBackground: uploadUserVirtualBackground,
    deleteUserVirtualBackground: deleteUserVirtualBackground,
    resetUserVirtualBackground: resetUserVirtualBackground,
    setIsVideoChanging: setIsVideoChanging,
    setIsVideoDisconnected: setIsVideoDisconnected,
    onVideoReady: handleVideoReady,
    handleFirstNameChange: setFirstName,
    handleLastNameChange: setLastName
  }));
};
CameraSourceSettings.propTypes = {
  meetingSession: _propTypes["default"].object.isRequired,
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  audioInputDeviceId: _propTypes["default"].string,
  audioOutputDeviceId: _propTypes["default"].string,
  videoInputDeviceId: _propTypes["default"].string,
  isCameraAvailable: _propTypes["default"].bool.isRequired,
  userBackground: _propTypes["default"].oneOf([_constants.BACKGROUND_OPTIONS.NONE, _constants.BACKGROUND_OPTIONS.BLUR, _constants.BACKGROUND_OPTIONS.CUSTOM]),
  transformedVideoInputs: _propTypes["default"].array,
  user: _propTypes["default"].object,
  uploadUserVirtualBackground: _propTypes["default"].func,
  deleteUserVirtualBackground: _propTypes["default"].func
};